import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PurchasingGoodsReceiveNoteActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/GoodsReceiveNote/GoodsReceiveNoteBrowser")
	}

	render() {
		return (
			<Activity 
				name="PurchasingGoodsReceiveNote"
				RenderedComponent={this.RenderedComponent}
				context="PurchasingGoodsReceiveNote"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PurchasingGoodsReceiveNoteActivity)
